
import Vue from 'vue';

export default Vue.extend({
  name: 'ExpansionPanel',
  components: { },

  props: {
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    change() {
      this.open = !this.open;
    },
  },

});
